// Shared by the signup qualification step and the Charter application form.
// Both accept a scheme-less domain because that is what people type, and both
// send the normalised value to a server that re-validates it.

export function normalizeWebsiteUrl(raw: string): string {
    const trimmed = (raw || '').trim();
    if (!trimmed) return '';
    return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}

export function isValidWebsiteUrl(raw: string): boolean {
    const trimmed = (raw || '').trim();
    if (!trimmed) return false;
    try {
        const url = new URL(normalizeWebsiteUrl(trimmed));
        return (
            (url.protocol === 'http:' || url.protocol === 'https:') &&
            url.hostname.includes('.')
        );
    } catch {
        return false;
    }
}
